const languages = [
  {
    name: 'Français',
    shortName: 'FR',
    locale: 'fr-FR',
    country: 'FRANCE',
  },
  {
    name: 'Español',
    shortName: 'ES',
    locale: 'es-ES',
    country: 'España',
  },
  {
    name: 'English',
    shortName: 'EN',
    locale: 'en-GB',
    country: 'England',
  },
  {
    name: 'Italiano',
    shortName: 'IT',
    locale: 'it-IT',
    country: 'Italia',
  },
];

export const getLanguageByLocale = locale => {
  const rez = languages.filter(lnObj => lnObj.locale === locale)[0];
  return rez || languages.filter(lnObj => lnObj.shortName === 'FR')[0];
};

export const getLanguageByShortName = shortName => {
  const rez = languages.filter(languageObject => languageObject.shortName === shortName)[0];
  return rez || languages.filter(languageObject => languageObject.shortName === 'FR')[0];
};

export const languageShortNames = languages.map(language => language.shortName);

export default languages;
